var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSternGruppe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Stern-Gruppe__Icn/40px/Stern-Gruppe",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Stern-Gruppe__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Stern-Gruppe__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.5,14 L15.2919799,19.6571693 L21.5350369,20.5643386 L17.0175185,24.9678307 L18.0839599,31.1856614 L12.5,28.25 L6.9160401,31.1856614 L7.98248155,24.9678307 L3.4649631,20.5643386 L9.70802005,19.6571693 L12.5,14 Z M20.3606798,9.76854361 L23.369,16.061 L30.0226895,17.0596257 L25.21,21.902 L26.3619672,28.8310854 L21.0887778,25.8444497 L22.0374651,24.169452 L23.801,25.168 L23.1500319,21.2442488 L25.977,18.399 L22.0733568,17.8137616 L20.36,14.231 L18.8683607,17.3528518 L17.1316393,16.5225364 L20.3606798,9.76854361 Z M12.5,18.35 L10.9863462,21.4166342 L7.602,21.908 L10.0508566,24.2957749 L9.472,27.667 L12.5,26.0751817 L15.527,27.667 L14.9491434,24.2957749 L17.397,21.908 L14.0136538,21.4166342 L12.5,18.35 Z M28.3606798,6.76854361 L31.368,13.061 L38.0226895,14.0596257 L33.21,18.902 L34.3619672,25.8310854 L29.0887778,22.8444497 L30.0374651,21.169452 L31.801,22.168 L31.1500319,18.2442488 L33.977,15.399 L30.0733568,14.8137616 L28.36,11.231 L26.8683607,14.3528518 L25.1316393,13.5225364 L28.3606798,6.76854361 Z",
    id: ".._.._src_svg_Icn_40px_Stern-Gruppe__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSternGruppe);
export default __webpack_public_path__ + "static/media/Stern-Gruppe.dea1c1197c6cbbf163656d9b556834e1.svg";
export { ForwardRef as ReactComponent };